module.exports = __webpack_public_path__ + "static/img/profile.d25a6cc8.gif";